export default __webpack_public_path__ + "static/media/clippers-icon.973542ab.jpeg";